// extracted by mini-css-extract-plugin
export var ancoraFooter = "footer-module--ancoraFooter--f5114";
export var fontCreditos = "footer-module--fontCreditos--c8ccb";
export var svgIcon = "footer-module--svgIcon--12d9f";